import { Injectable } from '@angular/core';
import { Incompatibilities } from '../Incompatibilities';
import { Fuente } from '../model';
import { Gabinete } from '../model/Gabinete';
import { FuncionCompatilibidadBase } from './FuncionesCompatibilidadBase';
import { IncompatibilitiesType } from '@core/enums/incompatibilities-types.enum';

@Injectable({
  providedIn: 'root',
})
export class FC_GabineteFuente extends FuncionCompatilibidadBase<Gabinete, Fuente> {
  funciones = {
    altura: (gabinete: Gabinete, fuente: Fuente): Incompatibilities | null =>
      (
        gabinete.$caracteristicas.posicion_fuente_superior == 0 &&
        fuente.$caracteristicas.compatible_abajo == 0
      ) ?
        {
          tipo: IncompatibilitiesType.PRODUCTO,
          incompatibility: 'La posicion de la fuente es incompatible con el gabinete',
        }
      : null,
    tipo: (gabinete: Gabinete, fuente: Fuente): Incompatibilities | null =>
      gabinete.$caracteristicas.tipo_fuente != fuente.$caracteristicas.tipo ?
        {
          tipo: IncompatibilitiesType.PRODUCTO,
          incompatibility: 'El tipo de fuente y gabinete no son compatibles',
        }
      : null,
  };
}
